import React, { FC, lazy } from 'react';
import { Routes as ReactRouter, Route } from 'react-router-dom';

import Loadable from './components/Loadable';
import { ROUTES } from './utils/constants';

const HomePage = Loadable(lazy(() => import('./pages/HomePage')));
const SkillsPage = Loadable(lazy(() => import('./pages/Skills')));
const ProjectsPage = Loadable(lazy(() => import('./pages/Projects')));
const EducationPage = Loadable(lazy(() => import('./pages/Education')));
const ContactMePage = Loadable(lazy(() => import('./pages/ContactMe')));

const Routes: FC = () => {
  return (
    <ReactRouter>
      <Route path={ROUTES.HOME} element={<HomePage />} />
      <Route path={ROUTES.SKILLS} element={<SkillsPage />} />
      <Route path={ROUTES.PROJECTS} element={<ProjectsPage />} />
      <Route path={ROUTES.EDUCATION} element={<EducationPage />} />
      <Route path={ROUTES.CONTACTME} element={<ContactMePage />} />
    </ReactRouter>
  );
};

export default Routes;
